export default __webpack_public_path__ + "static/media/4-icon.4a78c105.svg";